import { render } from "./WCCollapseCard.vue?vue&type=template&id=732d7a0e&scoped=true"
import script from "./WCCollapseCard.vue?vue&type=script&lang=js"
export * from "./WCCollapseCard.vue?vue&type=script&lang=js"

import "./WCCollapseCard.vue?vue&type=style&index=0&id=732d7a0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732d7a0e"]])

export default __exports__